import api from './api';

export interface Case {
  id: number;
  case_name: string;
  client_email?: string;
  case_type: string;
  case_state?: string;
  service_type_id: number;
  service_type?: { name: string };
  service_type_price?: number;
  rush_fee_amount?: number;
  total_amount?: number;
  retainer_amount?: number;
  balance_amount?: number;
  is_rush?: boolean;
  due_date: string;
  status: string;
  rejection_comment?: string;
  firm?: { name: string };
  creator?: { name: string };
  notes?: any[];
  attachments?: any[];
  meeting_link?: string;
  meeting_status?: string;
  meeting_slot_id?: number;
  invoice_date?: string;
  payment_date?: string;
  payment_status?: string;
}

export interface CreateCaseData {
  case_name: string;
  client_email?: string;
  case_type: string;
  case_state: string;
  service_type_id: number;
  due_date?: string;
  firm_id: number;
}

export interface UpdateStatusData {
  status: string;
  note?: string;
}

export interface CreateTeamsMeetingData {
  slot_id: number;
  meeting_subject?: string;
  meeting_body?: string;
}

const caseService = {
  // Get all cases
  getAllCases: () => api.get('/cases'),

  // Get case by ID
  getCase: (id: number) => api.get(`/cases/${id}`),

  // Create new case
  createCase: (data: CreateCaseData) => api.post('/cases', data),

  // Update case status
  updateStatus: (id: number, data: UpdateStatusData) =>
    api.patch(`/cases/${id}/status`, data),

  // Mark retainer received
  markRetainerReceived: (id: number) =>
    api.patch(`/cases/${id}/retainer-received`),

  // Update retainer amount
  updateRetainerAmount: (id: number, data: { retainer_amount: number }) =>
    api.post(`/cases/${id}/update-retainer-amount`, data),

  // Update invoice details
  updateInvoiceDetails: (id: number, data: { invoice_date?: string; payment_date?: string }) =>
    api.post(`/cases/${id}/update-invoice-details`, data),

  // Submit retainer form
  submitRetainerForm: (id: number, data: FormData) =>
    api.post(`/cases/${id}/submit-retainer-form`, data),

  // Mark invoice as paid
  markInvoicePaid: (id: number) => api.patch(`/cases/${id}/mark-invoice-paid`),

  // Add note to case
  addNote: (id: number, data: { note: string; action_type: string }) =>
    api.post(`/cases/${id}/notes`, data),

  // Download attachment
  downloadAttachment: (id: number) =>
    api.get(`/admin/attachments/${id}/download`, { responseType: 'blob' }),

  // Azure Calendar Integration
  getAzureCalendarSlots: (caseId: number) =>
    api.get(`/cases/${caseId}/azure-calendar-slots`),
  createSlotsFromAzureCalendar: (caseId: number, data: any) =>
    api.post(`/cases/${caseId}/create-slots-from-azure`, data),
  sendSlotsToFirmAdmin: (caseId: number, data: any) =>
    api.post(`/cases/${caseId}/send-slots-to-firm-admin`, data),

  // Teams Meeting
  createTeamsMeeting: (caseId: number, data: CreateTeamsMeetingData) =>
    api.post(`/cases/${caseId}/create-teams-meeting`, data),
};

export default caseService;
